/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Order_TotalInputs */

const vi_reconcile_order_total = /** @type {(inputs: Reconcile_Order_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng`)
};

/**

* @param {Reconcile_Order_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_order_total = /** @type {((inputs?: Reconcile_Order_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Order_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_order_total(inputs)
});